// @flow
import { styled } from 'mz-ui-kit'
import { getScreenStyles } from '../../../utils'

export const Container = styled('div', {
  marginBottom: '10px',
})

export const StillCantFindNotice = styled('div', {
  marginBottom: '10px',
})

export const Header = styled('h4', {
  marginBottom: '10px',
  marginTop: '20px',
})

export const ButtonContainer = styled(
  'div',
  getScreenStyles(
    'xs',
    {
      display: 'flex',
      justifyContent: 'stretch',
      flexFlow: 'column nowrap',
      margin: '10px 0',
    },
    {
      margin: '10px 0',
      width: 'auto',
      flexGrow: '-1',
    }
  )
)
